<template>
  <div class="vision-header">
    <div class="user" v-if="self">{{self.email}}</div>
    <div class="logo">
      <img v-if="!hasAppError" src="../../assets/icon_logo.svg"/>
      <img v-if="hasAppError" src="../../assets/icon_error.svg"/>
    </div>
    <div class="menu-button" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="menu" v-if="menuOpened">
      <router-link tag="a" class="menu-item" to="/tech/contacts" @click.native="toggleMenu" :target="isCallInProgress? '_blank': ''">Contacts</router-link>
      <router-link tag="a" class="menu-item" to="/tech/session-logs" @click.native="toggleMenu" :target="isCallInProgress? '_blank': ''">Session Logs
      </router-link>
      <div class="menu-item" @click="logoutUser">Logout</div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex';

  export default {
    name: 'VisionHeader',
    data: () => ({
      menuOpened: false
    }),

    computed: {
      ...mapState({
        self: state => state.auth.self,
        hasAppError: state => state.global.hasAppError,
        isCallInProgress: state => state.global.isCallInProgress
      })
    },

    methods: {
      toggleMenu(e) {
        e.stopPropagation();
        this.menuOpened = !this.menuOpened;

        if (this.menuOpened) {
          document.addEventListener('click', this.toggleMenu)
        } else {
          document.removeEventListener('click', this.toggleMenu)
        }
      },
      logoutUser() {
        if(this.isCallInProgress) {
          return;
        }
        this.$store.dispatch('auth/logout');
        this.$router.push('/log-in');
      }
    },
  }
</script>

<style lang="scss">
  @import "VisionHeader";
</style>
